import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { uploadLogo } from '../../redux/actions/settings';

const UploadStoreLogo = ({ payload, settings, uploadLogo }) => {
  const [submitted, setSubmitted] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    if(e.target.files[0]) {
      setSubmitted(false);

      if(e.target.files[0].size <= 1048576) {
        setError(null);
        setFile(e.target.files[0]);
      } else {
        setError('File size is too large (max size 1MB).');
        setFile(null);
      }

    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (file !== undefined && !file.cancelled && file.name) {
      uploadLogo(payload, file);
    }
  }

  return(
    <div className="a-card a-card--compact">
      <div className="a-card__paddings">
        <h3>Store Logo</h3>
        <h4>Current Logo:</h4>
        { settings.settings.logo_location &&
          <>
            <img src={settings.logo_url} height="150" />
            <br/>
            <br/>
            <span>
              {settings.settings.logo_location}
            </span>
          </>
        }
        { !settings.settings.logo_location &&
          <span className="warning">No store logo set.</span>
        }
        <br/>
        <br/>
        <h4>Upload New Logo:</h4>
        <div className="muted">
          Supported file types: jpg, jpeg, png
        </div>
        <form onChange={ (e) => handleChange(e) } onSubmit={ (e) => handleSubmit(e) }>
          <input type="file" name="file" accept="image/png, image/jpeg" />
          <br/>
          <br/>
          <button className="btn btn-primary btn-medium" disabled={submitted || !file}>
            <span className="svg-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 11a4 4 0 0 1-4 4H4.5a4.5 4.5 0 0 1-1.214-8.834 6.002 6.002 0 0 1 11.648.944A4.002 4.002 0 0 1 18 11zm-4-3a3 3 0 0 1 0 6H4.5a3.5 3.5 0 0 1-1.442-6.69.5.5 0 0 0 .99-.004 4.988 4.988 0 0 1 .051-.302 5.002 5.002 0 0 1 9.803.006A.5.5 0 0 0 14 8z" fill="currentColor"/></svg>
            </span>
            <span className="gwt-InlineLabel">Upload Logo</span>
          </button>
        </form>
        { error && 
          <span className="error">{error}</span>
        }
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  uploadLogo: (payload, file) => dispatch(uploadLogo(payload, file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadStoreLogo);